import React from 'react'; 
import { Form, Button, Row, Col, ListGroup, Table, ButtonGroup } from "react-bootstrap";
import ImageUploading from 'react-images-uploading';

export default function GalleryGuidelisting() {
    const [images, setImages] = React.useState([]);
    const maxNumber = 69;
    
    const onChange = (imageList, addUpdateIndex) => {
    // data for submit
    console.log(imageList, addUpdateIndex);
    setImages(imageList);
    };
    return(
        <section className="admin-section">
            <div className="container">
                <div className="row">
                    <div className="col-md-12 col-12">
                        <div className="admin-edit gallery-guide">
                        <h1>SUBSCRIPTION DETAILS</h1>
                        <div className='table-responsive'>
                            <Table striped>
                                <tbody>
                                    <tr>
                                        <td>   Item<br />
                                                <i>Annual Subscription</i>
 
                                        </td>
                                        <td>
 
                                                State Date<br />
                                                <i>00/00/00</i>
 
                                        </td>
                                        <td>
 
                                                End Date<br />
                                                <i>00/00/00</i>
 
                                        </td>
                                        <td>
 
                                                Price<br />
                                                <i>$xx USD</i>
 
                                        </td>
                                        <td>
                                            <Button className='cancel-btn'>View Invoice</Button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>   Item<br />
                                                <i>Annual Subscription</i>
 
                                        </td>
                                        <td>
 
                                                State Date<br />
                                                <i>00/00/00</i>
 
                                        </td>
                                        <td>
 
                                                End Date<br />
                                                <i>00/00/00</i>
 
                                        </td>
                                        <td>
 
                                                Price<br />
                                                <i>$xx USD</i>
 
                                        </td>
                                        <td>
                                        <Button className='cancel-btn'>View Invoice</Button>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                            </div>
                            <div className='text-center'>
                                <Button className='common-btn'>View / Edit Listing</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}